import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { RedTextButton } from 'components/buttons/RedTextButton';

import { HotDealsFilters } from './HotDealsFilters';

const MobileFiltersContainer = styled.div`
  background-color: ${theme.color.white};
  width: 100%;
`;

const ShowResultsButton = styled(RedTextButton)`
  width: 100%;
  border: 1px solid ${theme.color.red};
`;

const Spacer = styled.div`
  width: 100%;
  border-top: 1px solid ${theme.color.darkGray};
`;

const PaddedContainer = styled.div`
  padding: 24px;
`;

interface Props {
  toggleFilters: () => void;
}

export const MobileHotDealsFilters = ({ toggleFilters }: Props) => {
  const { t } = useTranslation('common');

  return (
    <MobileFiltersContainer>
      <PaddedContainer>
        <HotDealsFilters />
      </PaddedContainer>
      <Spacer />
      <PaddedContainer>
        <ShowResultsButton onClick={toggleFilters}>{t('show-results')}</ShowResultsButton>
      </PaddedContainer>
    </MobileFiltersContainer>
  );
};
